import { GameSettings } from "./types";
import { contentTypeIds } from "../types";

export const clashofclans = {
  enabledTabs: ["news", "community", "esport", "blog"],
  enabledLocales: [
    "de",
    "en",
    "es",
    "fr",
    "id",
    "it",
    "ja",
    "ko",
    "pt",
    "pl",
    "zh",
    "zh-hans",
  ] as const,
  enabledNotificationTypes: ["standard"],
  referenceWidth: 850,
  availableButtonVariants: ["gray", "green", "red", "blue", "orange"],
  progressBarDefaultColor: "#7ab94e",
  availableCategories: [
    {
      id: "news",
      color: "#059816",
      name: {
        en: "News",
        fr: "Actualités",
        de: "news",
        id: "Berita",
        it: "Notizie",
        ja: "ニュース",
        ko: "뉴스",
        pt: "Novidades",
        es: "Novedades",
        tr: "Haberler",
        vi: "Tin tức",
        zh: "最新情報",
      },
    },
    {
      id: "esports",
      name: {
        en: "Esports",
        fr: "E-sport",
        de: "E-Sports",
        id: "Esports",
        it: "Esports",
        ja: "eスポーツ",
        ko: "e스포츠",
        pt: "E-sports",
        es: "eSports",
        tr: "E-spor",
        vi: "Thể thao điện tử",
        zh: "賽事",
      },
      color: "#19eb86",
    },
    {
      id: "game-updates",
      color: "#0ced50",
      name: {
        en: "Game Updates",
        fr: "Mises à jour",
        de: "Updates",
        id: "Pembaruan Game",
        it: "Aggiornamenti del gioco",
        ja: "ゲームアップデート",
        ko: "게임 업데이트",
        pt: "Atualizações do jogo",
        es: "Actualizaciones del juego",
        tr: "Oyun güncellemeleri",
        vi: "Bản cập nhật trò chơi",
        zh: "遊戲更新",
      },
    },
    {
      id: "release-notes",
      color: "#007a00",
      name: {
        en: "Release Notes",
        fr: "Notes de patch",
        de: "Versionshinweise",
        id: "Catatan Rilis",
        it: "Note di rilascio",
        ja: "リリース情報",
        ko: "변경 사항",
        pt: "Notas de lançamento",
        es: "Notas de actualización",
        tr: "Sürüm notları",
        vi: "Thông tin phiên bản",
        zh: "更新詳情",
      },
    },
    {
      id: "community",
      color: "#b35f8c",
      name: {
        en: "Community",
        fr: "Communauté",
        de: "community",
        id: "Komunitas",
        it: "community",
        ja: "コミュニティ",
        ko: "커뮤니티",
        pt: "Comunidade",
        es: "Comunidad",
        tr: "Oyuncu topluluğu",
        vi: "Cộng đồng",
        zh: "社群",
      },
    },
    {
      id: "clan-games",
      color: "#3dc8eb",
      name: {
        en: "Clan Games",
        fr: "Jeux de clan",
        de: "Clanspiele",
        id: "Permainan Klan",
        it: "Giochi del clan",
        ja: "クランゲーム",
        ko: "클랜 게임",
        pt: "Jogos do Clã",
        es: "Juegos del Clan",
        tr: "Klan oyunları",
        vi: "Trò chơi Hội",
        zh: "部落競賽",
      },
    },
    {
      id: "supercell",
      color: "#000000",
      name: {
        en: "Supercell",
        fr: "Supercell",
        de: "Supercell",
        id: "Supercell",
        it: "Supercell",
        ja: "Supercell",
        ko: "슈퍼셀",
        pt: "Supercell",
        es: "Supercell",
        tr: "Supercell",
        vi: "Supercell",
        zh: "Supercell",
      },
    },
    {
      id: "misc",
      color: "#000000",
      name: {
        en: "Misc",
        fr: "Divers",
        de: "Sonstiges",
        id: "Lain-lain",
        it: "Altro",
        ja: "その他",
        ko: "기타",
        pt: "Diversos",
        es: "Otros",
        tr: "Diğer",
        vi: "Khác",
        zh: "其他",
      },
    },
  ],

  enabledComposePages: ["news", "events"],

  resolutions: {
    [contentTypeIds.newsEntryExternalLink]: {
      linkThumbnail: {
        width: 900,
        height: 506,
      },
    },
    [contentTypeIds.newsEntryArticle]: {
      heroImage: {
        width: 1950,
        height: 800,
      },
      largeThumbnail: {
        width: 900,
        height: 506,
      },

      websiteHeroImage: {
        width: 3000,
        height: 600,
      },
    },
    [contentTypeIds.smallNewsEntryExternalLink]: {
      linkThumbnail: {
        width: 440,
        height: 440,
      },
    },
    [contentTypeIds.smallNewsEntryArticle]: {
      heroImage: {
        width: 1950,
        height: 800,
      },
      smallThumbnail: {
        width: 440,
        height: 440,
      },

      websiteHeroImage: {
        width: 3000,
        height: 600,
      },
    },
    [contentTypeIds.videoBlock]: {
      videoThumbnail: {
        width: 900,
        height: 506,
      },
    },
    [contentTypeIds.carouselEventPollEntry]: {
      carouselImage: {
        width: 860,
        height: 1320,
      },
      option1Image: {
        width: 300,
        height: 400,
      },
      option2Image: {
        width: 300,
        height: 400,
      },
      option3Image: {
        width: 300,
        height: 400,
      },
      option4Image: {
        width: 300,
        height: 400,
      },
      option5Image: {
        width: 300,
        height: 400,
      },
    },
    [contentTypeIds.carouselEventProgressTrackerEntry]: {
      carouselImage: {
        width: 1280,
        height: 720,
      },
      milestone1Image: {
        width: 256,
        height: 256,
      },
      milestone2Image: {
        width: 256,
        height: 256,
      },
      milestone3Image: {
        width: 256,
        height: 256,
      },
      milestone4Image: {
        width: 256,
        height: 256,
      },
      milestone5Image: {
        width: 256,
        height: 256,
      },
      milestone6Image: {
        width: 256,
        height: 256,
      },
      milestone7Image: {
        width: 256,
        height: 256,
      },
      milestone8Image: {
        width: 256,
        height: 256,
      },
    },
    [contentTypeIds.esportCarouselEventEntry]: {
      carouselImage: {
        width: 860,
        height: 1280,
      },
    },
    [contentTypeIds.esportLiveEventEntry]: {
      carouselImage: {
        width: 1280,
        height: 720,
      },
      eventPromotionLogo: {
        width: 256,
        height: 256,
        fit: "pad",
      },
    },
    [contentTypeIds.newsEntryVideo]: {
      videoThumbnail: {
        width: 900,
        height: 506,
      },
    },
    [contentTypeIds.imageBlock]: {
      image: null,
    },
    [contentTypeIds.featureBlock]: {
      featureThumbnail: {
        width: 700,
        height: 700,
        fit: "default",
      },
    },
    [contentTypeIds.pollBlock]: {
      option1Image: {
        width: 300,
        height: 400,
      },
      option2Image: {
        width: 300,
        height: 400,
      },
      option3Image: {
        width: 300,
        height: 400,
      },
      option4Image: {
        width: 300,
        height: 400,
      },
      option5Image: {
        width: 300,
        height: 400,
      },
    },
    [contentTypeIds.carouselEventEntry]: {
      carouselImage: {
        width: 860,
        height: 1320,
      },
    },

    [contentTypeIds.communityCreator]: {
      communityCreatorThumbnail: {
        width: 50,
        height: 50,
      },
    },

    [contentTypeIds.communityVideoEntry]: {
      communityEntryVideoThumbnail: {
        width: 640,
        height: 358,
      },
    },

    [contentTypeIds.communityLivestreamEntry]: {
      livestreamEntryVideoThumbnail: {
        width: 640,
        height: 358,
      },
    },

    [contentTypeIds.esportRewatchMatchEntry]: {
      matchThumbnail: {
        width: 900,
        height: 506,
      },
      playerOneImage: {
        width: 256,
        height: 256,
      },
      playerTwoImage: {
        width: 256,
        height: 256,
      },
    },

    [contentTypeIds.newsEntryImage]: {
      imageNewsThumbnail: {
        width: 900,
        height: 506,
      },
    },

    [contentTypeIds.fullscreenEntryCarousel]: {
      backgroundMedia: {
        width: 1620,
        height: 1080,
      },
    },

    [contentTypeIds.webEvent]: {
      backgroundImage: {
        width: 1920,
        height: 1080,
      },
    },

    [contentTypeIds.localizedHero]: {
      image: {
        width: 1920,
        height: 720,
      },
    },

    [contentTypeIds.localizedSpotlight]: {
      image: {
        width: 1280,
        height: 720,
      },
    },
  },

  blogMeta: {
    site: "@clashofclans",
    creator: "@clashofclans",
  },

  activeContentInDays: {
    community: 90,
    news: 90,
    esport: 90,
  },

  esport: {
    enableCarouselTitle: true,
  },
  supportPolls: true,
  supportTargetPolls: false,
  supportSmallArticles: true,
  supportFullscreenEntries: true,
  supportProgressTrackerEntry: true,
  eventPlatformEnabled: true,
  ingameProgressTrackersEnabled: true,
  leaderboardEnabled: true,
  gridEnabled: true,

  targetingFields: [
    "country",
    "platform",
    "countryExclude",
    "townHallLevel",
    "builderHallLevel",
    "campaignId",
    "avatarIds",
  ],
  targetingPlatforms: ["iOS", "Android", "Amazon"],
} satisfies GameSettings;
